import * as actionTypes from "../actions/actionTypes";
import { cloneDeep } from "lodash";

const INITIAL_STATE = {
  homeRecommendedRes: {
    data: [],
    total: "",
  },
  restaurantDetail: {},
  deliveryAnnouncement: false,
  restaurantList: {
    offset: 0,
    limit: 10,
    data: [],
    distance: 0,
    isLoading: false,
    hasMore: true,
    meta: {
      page: 0,
      pageSize: 0,
      pageTotal: 0,
      total: 0,
    },
  },
  restaurantAlbum: {
    data: [],
    offset: 0,
    limit: 10,
    isLoading: false,
    hasMore: true,
  },
  restaurantCoverage: {},
  // General
  stateList: [],
  categoryList: [],
  cuisineList: [],
  ambienceList: [],
  otherList: [],
  tempFilter: {},
  tempList: {},
};

export default function restaurantReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actionTypes.LOAD_DELIVERY_ANNOUNCEMENT: {
      return {
        ...state,
        deliveryAnnouncement: false,
      };
    }
    case actionTypes.LOAD_DELIVERY_ANNOUNCEMENT_SUCCESS: {
      return {
        ...state,
        deliveryAnnouncement: action.data,
      };
    }
    case actionTypes.LOAD_DELIVERY_ANNOUNCEMENT_FAIL: {
      return {
        ...state,
      };
    }
    case actionTypes.HOME_RECOMMENDED_RESTAURANT: {
      return {
        ...state,
        homeRecommendedRes: {},
      };
    }
    case actionTypes.HOME_RECOMMENDED_RESTAURANT_SUCCESS: {
      return {
        ...state,
        homeRecommendedRes: {
          data: action.data.data.result,
          total: action.data.total,
        },
      };
    }
    case actionTypes.LOAD_RESTAURANT_LOADED:
    case actionTypes.LOAD_RESTAURANT: {
      let restaurantList = cloneDeep(state.restaurantList);
      restaurantList.offset = action.data.offset;
      restaurantList.limit = action.data.limit;
      restaurantList.isLoading = true;
      restaurantList.hasMore = false;

      // offset 0 then clear data
      if (restaurantList.offset === undefined || restaurantList.offset === 0) {
        restaurantList.data = [];
      }

      if (action.pagination) {
        restaurantList.data = [];
      }
      return {
        ...state,
        restaurantList: restaurantList,
      };
    }
    case actionTypes.LOAD_RESTAURANT_SUCCESS: {
      let passed_param = {};
      let loaded_shop = {};
      if (action.params) {
        passed_param = JSON.parse(JSON.stringify(action.params));
        delete passed_param.offset;
      }
      let restaurantList = cloneDeep(state.restaurantList);
      const data = action.data;
      if (data.data.distance) restaurantList.distance = data.data.distance;
      restaurantList.isLoading = false;
      restaurantList.hasMore = true;
      restaurantList.data = [...restaurantList.data, ...data.data.result];

      if (
        restaurantList.data.length === 0 ||
        data.data.result.length < restaurantList.limit
      ) {
        restaurantList.hasMore = false;
      }

      // If load all restaurant (offset and limit is undefined)
      if (
        restaurantList.offset === undefined &&
        restaurantList.limit === undefined
      ) {
        restaurantList.hasMore = false;
      }

      // With Pagination
      if (action.pagination) {
        restaurantList.data = data.data.result;

        restaurantList.meta = {
          page: 1 + restaurantList.offset / restaurantList.limit,
          pageSize: restaurantList.limit,
          pageTotal: Math.ceil(data.total / restaurantList.limit),
          total: data.total,
        };

        if (restaurantList.meta.page === restaurantList.meta.pageTotal) {
          restaurantList.hasMore = false;
        }
        if (JSON.stringify(state.tempFilter) === JSON.stringify(passed_param)) {
          loaded_shop = state.tempList;
        }
        loaded_shop[1 + restaurantList.offset / restaurantList.limit] =
          data.data.result;
      }

      return {
        ...state,
        restaurantList: restaurantList,
        tempFilter: passed_param,
        tempList: loaded_shop,
      };
    }
    case actionTypes.LOAD_RESTAURANT_LOADED_SUCCESS: {
      let restaurantList = cloneDeep(state.restaurantList);
      restaurantList.isLoading = false;
      restaurantList.hasMore = true;
      restaurantList.meta = {
        page: 1 + restaurantList.offset / restaurantList.limit,
        pageSize: restaurantList.limit,
        pageTotal: restaurantList.meta.pageTotal,
        total: restaurantList.meta.total,
      };
      if (restaurantList.meta.page === restaurantList.meta.pageTotal) {
        restaurantList.hasMore = false;
      }

      restaurantList.data =
        state.tempList[1 + restaurantList.offset / restaurantList.limit];
      return {
        ...state,
        restaurantList: restaurantList,
      };
    }
    case actionTypes.LOAD_RESTAURANT_FAIL: {
      let restaurantList = cloneDeep(state.restaurantList);
      restaurantList.isLoading = false;
      restaurantList.hasMore = false;

      return {
        ...state,
        restaurantList: restaurantList,
      };
    }
    case actionTypes.GET_RESTAURANT_DETAIL: {
      return {
        ...state,
        restaurantDetail: {},
        restaurantAlbum: INITIAL_STATE.restaurantAlbum,
      };
    }
    case actionTypes.GET_RESTAURANT_DETAIL_SUCCESS: {
      return {
        ...state,
        restaurantDetail: action.data,
      };
    }
    case actionTypes.GET_RESTAURANT_DETAIL_FAIL: {
      return {
        ...state,
      };
    }

    case actionTypes.LOAD_RESTAURANT_ALBUM: {
      let restaurantAlbum = cloneDeep(state.restaurantAlbum);
      restaurantAlbum.offset =
        action.offset !== undefined
          ? action.offset
          : INITIAL_STATE.restaurantAlbum.offset;
      restaurantAlbum.limit =
        action.limit !== undefined
          ? action.limit
          : INITIAL_STATE.restaurantAlbum.limit;
      restaurantAlbum.isLoading = true;
      restaurantAlbum.hasMore = false;

      // offset 0 then clear data
      if (restaurantAlbum.offset === 0) {
        restaurantAlbum.data = [];
      }

      return {
        ...state,
        restaurantAlbum,
      };
    }

    case actionTypes.LOAD_RESTAURANT_ALBUM_SUCCESS: {
      let restaurantAlbum = cloneDeep(state.restaurantAlbum);
      restaurantAlbum.data = [...restaurantAlbum.data, ...action.data];
      restaurantAlbum.isLoading = false;
      restaurantAlbum.hasMore = true;

      if (
        restaurantAlbum.data.length === 0 ||
        action.data.length < restaurantAlbum.limit
      ) {
        restaurantAlbum.hasMore = false;
      }

      return {
        ...state,
        restaurantAlbum,
      };
    }

    case actionTypes.LOAD_RESTAURANT_ALBUM_FAIL: {
      return {
        ...state,
        restaurantAlbum: INITIAL_STATE.restaurantAlbum,
      };
    }

    case actionTypes.CHECK_RESTAURANT_COVERAGE: {
      return { ...state, restaurantCoverage: {} };
    }
    case actionTypes.CHECK_RESTAURANT_COVERAGE_SUCCESS: {
      return { ...state, restaurantCoverage: action.data };
    }
    case actionTypes.CHECK_RESTAURANT_COVERAGE_FAIL: {
      return { ...state, restaurantCoverage: INITIAL_STATE.restaurantCoverage };
    }

    // General
    case actionTypes.GET_STATE_LIST:
    case actionTypes.GET_STATE_LIST_FAIL: {
      return {
        ...state,
        stateList: [],
      };
    }
    case actionTypes.GET_STATE_LIST_SUCCESS: {
      return {
        ...state,
        stateList: action.data,
      };
    }

    case actionTypes.GET_RESTAURANT_FILTER_LIST:
    case actionTypes.GET_RESTAURANT_FILTER_LIST_FAIL: {
      let type = "";
      switch (action.data) {
        case "ambience":
          type = "ambienceList";
          break;
        case "category":
          type = "categoryList";
          break;
        case "cuisine":
          type = "cuisineList";
          break;
        case "other":
          type = "otherList";
          break;
        default:
          break;
      }
      return {
        ...state,
        [type]: [],
      };
    }
    case actionTypes.GET_RESTAURANT_FILTER_LIST_SUCCESS: {
      let type = "";
      switch (action.filter) {
        case "ambience":
          type = "ambienceList";
          break;
        case "category":
          type = "categoryList";
          break;
        case "cuisine":
          type = "cuisineList";
          break;
        case "other":
          type = "otherList";
          break;
        default:
          break;
      }
      return {
        ...state,
        [type]: action.data,
      };
    }
    default:
      return state;
  }
}
